<h1 mat-dialog-title class="!mb-0 !text-[2.2rem] text-darkGray text-center">{{title}}</h1>

<mat-divider class="!my-3"></mat-divider>

<mat-dialog-content class="max-w-screen-sm w-full !mx-auto text-center">
  <p class="font-primary text-[#3A4856] text-center whitespace-pre-line">
    {{confirmMessage}}
  </p>

  <p class="font-primary inline-block text-[#979797] italic text-center">
    <mat-icon class="!text-[#FFAE37] mr-1 relative top-1">warning</mat-icon>
   {{confirmMessageSecond}}
  </p>
</mat-dialog-content>

<mat-dialog-actions align="center" class="!pb-5 gap-6" >
  <button mat-button class="bg-grey-800 text-white w-48" [mat-dialog-close]="ConfirmRequestDialogAction.Cancel">Cancel
  </button>
  <button type="button" [mat-dialog-close]="ConfirmRequestDialogAction.Confirm" mat-raised-button color="primary"
    class="w-48"[class.warning]="isArlert">Yes
  </button>
</mat-dialog-actions>